import axios from 'axios'
import router from '../../../router/index'
const api = process.env.VUE_APP_URL;
import roleGroup from './roleGroup'

function delDouble(arr, property, property2) {
  let a = arr.concat();
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (!property2) {
        if (a[i][property] == a[j][property]) {
          a.splice(j--, 1);
        }
      } else {
        if (a[i][property][property2] == a[j][property][property2]) {
          a.splice(j--, 1);
        }
      }
    }
  };
  return a
};

export default {
  namespaced: true,
  state() {
    return {
      //popups
      assignedRoleGroup: '',

      //присвоеные к акку роли
      assignedRoles: [],

      //все роли
      ownedRoles: [],
      allRoles: '',
      checkedRoles: [],
      //массив ролей отображаемых в таблице tableComponent
      displayedRolesInCell: [],

      //пользователи
      users: [],
      invitedUsers: [],

      doubleMailError: false,
      inviteSuccess: false,

      windoWidth: window.innerWidth,

      dirName: '',

      allRolesTags: '',
      activeRolesTags: '',

      allNotify: [],
      singleNotify: '',
    }
  },
  getters: {
    interfaceSingleItems(state) {
      if (state.allRoles && state.users) {
        let arr = state.allRoles.concat(state.ownedRoles);
        if (arr) {
          arr = delDouble(arr, 'id').filter(item => {
            return !item.user
          });
        }

        return arr.map(item => {
          item.users = [];
          for (let user of state.users) {
            for (let role of user.roles) {
              if (role.role_id == item.id) {
                item.users.push(user);
              }
            }
          }
          return item;
        })
      } else {
        return []
      };


    },
    allSingleChecked(state) {
      let marker = true;

      let arr = state.allRoles.concat(state.ownedRoles);
      if (arr) {
        arr = delDouble(arr, 'id').filter(item => {
          return !item.user
        });
      }

      if (!arr.length) return false;
      if (state.checkedRoles.length != arr.length) {
        marker = false;
      };
      return marker;
    },
    activeRole(state) {
      let routeId = router.history.current.params.id;
      const users = state.users;

      let arr = state.allRoles.concat(state.ownedRoles);
      if (arr) {
        arr = delDouble(arr, 'id').filter(item => {
          return !item.user
        });
      }

      let role;

      function setUsersToRole(role) {
        let usersRole = [];
        //по всем юзерам
        for (let i = 0; i < users.length; i++) {
          let user = users[i];
          //по всем пикрепелнным к юзеру ролям
          for (let j = 0; j < user.roles.length; j++) {
            if (user.roles[j].role_id == role.id) {
              usersRole.push(users[i])
            }
          }
        };
        role.users = usersRole;
        return role
      };

      if (arr) {
        //проходим по ролям
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          if (item.id == routeId) {
            role = item;
            role.parent = '';
            break;
          }
        };
        if (role) {
          return setUsersToRole(role);
        }
      }
      return role
    },

  },
  mutations: {
    SET_ALL_ROLES(state,data) {
      state.allRoles = data
    },
    SET_DIR_NAME(state,data) {
      state.dirName = data
    },
    SET_SUCCESS_INVITE(state,data) {
      state.successInvite = data
    },
    SET_INVITED_USERS(state,data) {
      state.invitedUsers = data
    },
    SET_MOVED_EL(state,data) {
      state.movedEl = data
    },
    SET_MOVED_GROUP(state,data) {
      state.movedGroup = data
    },
    SET_ASSIGNED_ROLES(state,data) {
      state.assignedRoles = data
    },
    SET_OWNED_ROLES(state,data) {
      //сохраняем все
      state.ownedRoles = data.map(item => {
        return {
          ...item,
          checked: false
        }
      });
    },
    SET_ALL_ROLES_TAGS(state,data) {
      state.allRolesTags = data;
    },
    SET_ACTIVE_TAGS(state,data){
      state.activeRolesTags = data
    },
    TOGGLE_CHECKED_ROLES(state,data) {
      state.checkedRoles = data
    },
    SET_DOUBLE_MAIL(state,data) {
      state.doubleMailError = data
    },
    SET_INNVITE_SUCCESS(state,data) {
      state.inviteSuccess = data
    },
    SET_USERS(state,data) {
      state.users = data
    },
    SET_ALL_NOTIFY(state,data) {
      state.allNotify = data
    },
    SET_DISPLAYED_ROLES_IN_CELL(state, data) {
      state.displayedRolesInCell = data
    }
  },
  actions: {
    //users/delete-user
    //user_id
    //юзеры
    async getUsers({commit, dispatch, rootState}, token) {
      let data;
      await axios({
        method: 'get',
        url: `${api}users/get-assigned-users`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_USERS', res.data)
        data = res.data
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
      return data;
    },
    async getInvitedUsers({commit,dispatch, rootState}, token) {
      await axios({
        method: 'get',
        url: `${api}users/get-invited-users`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_INVITED_USERS', res.data)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    async deleteUser({dispatch, rootState}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/delete-user`,
        data: {
          user_id: obj.id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(() => {
        dispatch('getUsers', obj.token);
        dispatch('getInvitedUsers', obj.token);
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    async reinviteUser({commit, rootState}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/re-invite`,
        data: {
          email: obj.email
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('popups/SHOW_OVERLAY', true, {root: true});
        commit('SET_INNVITE_SUCCESS', true);
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },

    //СТЭЙТ РОЛЕЙ

    //созданные юзером роли
    async getOwnedRoles({state, commit, dispatch,rootState}, obj) {
      await axios({
        method: 'get',
        url: `${api}users/get-owned-roles`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(async res => {
        commit('SET_OWNED_ROLES', res.data);

        let tags_arr = [];

        for (let i = 0; i < res.data.length; i++) {
          for (let x = 0; x < res.data[i].tags.length; x++) {
            let is_unique = true;

            for (let y = 0; y < tags_arr.length; y++) {
              if(tags_arr[y].id == res.data[i].tags[x].id) {
                is_unique = false;
              }
            }

            if(is_unique) {
              tags_arr.push(res.data[i].tags[x]);
            }
          }
        }

        commit('SET_ALL_ROLES_TAGS', tags_arr);
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //прикрепленные к юзеру роли
    async getAssignedRoles({commit, dispatch, rootState}, token) {
      if (token != null && token != 'null') {
        await axios({
          method: 'get',
          url: `${api}users/get-assigned-roles?status=1`,
          headers: {
            'Authorization': rootState.auth.token
          }
        }).then((res) => {
          commit('SET_ASSIGNED_ROLES', res.data)
        }).catch(e => {
          let res = e.response.data;

          if (res.message.includes('access')) {
            dispatch('auth/logout', '', {root: true})
          }
        })
      }
    },

    //УПРАЛВЕНИЕ РОЛЯМИ

    //переключение активной роли
    async switchRole({rootState, commit, dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/switch-role`,
        data: {
          //access_token: obj.token,
          id: obj.id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        dispatch('auth/loadUser', '', {root: true})
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    async deleteRoleAssignment({rootState,commit,dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/delete-role-assignment`,
        data: {
          //access_token: obj.token,
          user_id: obj.userId,
          role_id: obj.roleId
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(() => {
        dispatch('getUsers', obj.token);
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //создание роли
    async createRole({rootState,commit, dispatch}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}users/create-role`,
        data: obj,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        data = res.data
      }).catch(e => {
        let res = e.response.data;

        console.log(e)

        // if (res.message.includes('access')) {
        //   dispatch('auth/logout', '', {root: true})
        // }
      })
      return data
    },
    //апдейт роли
    async updateRole({dispatch,rootState}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/update-role`,
        data: obj.data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        if (obj.reloadData) {
          dispatch('getOwnedRoles', {token: obj.token, id: ''});
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //удаление роли
    async deleteRole({rootState,state,commit, dispatch}, obj) {
      await axios ({
        method: 'post',
        url: `${api}users/delete-role`,
        data: {
          //access_token: obj.token,
          id: obj.id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(async res => {
        dispatch('getOwnedRoles', {token: obj.token, id: ''})
      }).catch(e => {
        console.log(e);
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //НОТИФИКАЦИИ

    //отправка приглашения юзеру
    async assignRoleToUser({rootState, commit,dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/assign-user-to-roles`,
        data: {
          //access_token: obj.token,
          roles_ids: obj.ids,
          user_email: obj.email,
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        if (e.response.status == 500) {
          throw new Error('error')
        }
      })
    },
    async inviteUser({rootState,commit,dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/invite`,
        data: {
        //  access_token: obj.token,
          email: obj.email
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
        if (res.status == 500) {
          throw new Error('error')
        };

        if (res.status == 400) {
          throw new Error('registered')
        }
      })
    },
    //получение списка инвайтов на роль
    async getAllNotify({rootState,commit,dispatch}) {
      await axios({
        method: 'get',
        url: `${api}notify/get`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        commit('SET_ALL_NOTIFY', res.data)
      })
    },

    //подтверждение инвайта
    async confirmInvite({rootState,commit,dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/confirm-role-assignment`,
        data: {
        //  access_token: obj.token,
          role_id: obj.role_id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        dispatch('getAssignedRoles', obj.token);
      }).catch(e => {

        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //отклонить инвайт
    async rejectInvite({rootState,commit,dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}users/reject-role-assignment`,
        data: {
          //access_token: obj.token,
          role_id: obj.role_id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        dispatch('getAssignedRoles', obj.token);
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    async readInvite({rootState,commit,dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}notify/read`,
        data: {
          //access_token: obj.token,
          id: obj.notify_id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        // console.log(res.data)
        dispatch('getAssignedRoles', obj.token);
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    // ТЕГИ
    async createRoleTag({state,dispatch,commit, rootState}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}tags/set`,
        data: obj,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        data = res.data;

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },
    async unsetRoleTag({state,dispatch,commit, rootState}, obj) {
      let data;
      await axios({
        method: 'post',
        url: `${api}tags/unset`,
        data: obj,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        data = res.data;

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return data
    },
  },
  modules: {
    roleGroup
  }
}
